import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/feedSettingsFilled.svg';

export const IconFeedSettingsFilled = createIconComponent(Icon);
